import { createContext } from 'react';

interface PageContextProps {
  // breadcrumbContext: Breadcrumbs;
  // isBreadcrumbBlokEnabled: boolean;
  headerIsTransparent: boolean;
  isHeaderSearchFunctionalityRequired: boolean;
  showContactBar: boolean;
}

export const PageContext = createContext<PageContextProps>({
  headerIsTransparent: false,
  isHeaderSearchFunctionalityRequired: true,
  showContactBar: true,
});
